/**
 * Module to clear cookies that are not allowlisted. Code referenced from cm-privacy-enabler plugin.
 *
 * @author Jonathan Li Kam Wa <jonathan.likamwa@system1.com>
 */

// eslint-disable-next-line import/no-unresolved
import Cookies from 'js-cookie';

const allowlistedCookies = [
  'gdpr_opt_in',
  'usprivacy',
  'euconsent-v2',
  'eupubconsent-v2',
  'OptanonAlertBoxClosed',
  'OptanonConsent',
  'OneTrustWPCCPAGoogleOptOut',
  'GoogleAdServingTest',
  'content_experiment_id',
  'OTGPPConsent',
];

/**
 * Get All Cookies
 * Transforms a cookie string into an
 * object with name/value pairs
 *
 * @return {{}}
 */
const getAllCookies = () => {
  const cookies = {};
  const list = document.cookie.split(';');

  for (let i = 0; i < list.length; i++) {
    const split = list[i].split('=');
    const cookieName = split[0].trim();
    const { 1: cookieVal } = split;
    cookies[cookieName] = cookieVal;
  }
  return cookies;
};

/**
 * Overwite the Cookie object in the DOM to prevent future cookies from being set.
 */
const overwriteCookieDom = () => {
  const cookieDesc = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie')
    || Object.getOwnPropertyDescriptor(HTMLDocument.prototype, 'cookie');

  if (cookieDesc && cookieDesc.configurable) {
    Object.defineProperty(document, 'cookie', {
      get() {
        return cookieDesc.get.call(window.document);
      },
      set(cookie) {
        const key = cookie.split('=')[0];
        if (allowlistedCookies.includes(key)) {
          console.log(`SET_COOKIE_ALLOWED:${cookie}`);
          cookieDesc.set.call(window.document, cookie);
        } else {
          console.log(`SET_COOKIE_NOT_ALLOWED:${cookie}`);
        }

        // eslint-disable-next-line no-setter-return
        return true;
      },
    });
  }
};

const deleteCookie = (cookie) => {
  const domains = [window.location.hostname];

  const re = /([a-z0-9]+\.[a-z0-9]+)$/;
  const domain = re.exec(window.location.hostname);
  domains.push(domain[0]);

  for (let i = 0; i < domains.length; i++) {
    // document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=' + paths[i] + ";";
    Cookies.remove(cookie);
    Cookies.remove(cookie, { domain: domains[i] });
    Cookies.remove(cookie, { domain: domains[i], secure: true });
  }
};

/**
 * Delete all the cookies that are not whitelisted.
 */
const processCookies = () => {
  const cookies = getAllCookies();

  console.log('PROCESSING COOKIES IF COOKIE IS ALLOWED.');

  Object.keys(cookies).forEach((cookieName) => {
    if (!allowlistedCookies.includes(cookieName)) {
      deleteCookie(cookieName);
      console.log(`DELETING COOKIE: ${cookieName}`);
    }
  });
};

const main = () => {
  // Delete all the cookies that are not whitelisted.
  processCookies();

  // Overwite the COokie object in the DOM to prevent future cookeis from being set.
  overwriteCookieDom();
};

export default main;
